import {
  TRACK_PLAYLISTED_FROM_SIM_SEARCH,
  TRACK_PLAYLISTED_FROM_SIM_TAB,
} from '@disco/constants/EventTypes'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import type { Track } from 'types/track'
import { DropdownMenu } from 'components/ds'

type Props = {
  track: Track
  closeMenu: () => void
}

const AddToPlaylist = ({ track }: Props): React.ReactNode => {
  const navigate = useNavigate()
  if (!track?.permissions?.manage) return null

  const internal_data = track.internal_data
  let linkTo = {}
  if (internal_data?.[TRACK_PLAYLISTED_FROM_SIM_TAB]) {
    linkTo = {
      ...internal_data[TRACK_PLAYLISTED_FROM_SIM_TAB],
      type: TRACK_PLAYLISTED_FROM_SIM_TAB,
    }
  }
  if (internal_data?.[TRACK_PLAYLISTED_FROM_SIM_SEARCH]) {
    linkTo = {
      ...internal_data[TRACK_PLAYLISTED_FROM_SIM_SEARCH],
      type: TRACK_PLAYLISTED_FROM_SIM_SEARCH,
    }
  }

  return (
    <DropdownMenu.Item
      onSelect={() =>
        navigate(`/explorer/tracks/${track.id}/add-to-playlist`, {
          state: { linkTo },
        })
      }
    >
      {!track?.permissions?.manage ? 'Import and add to playlist' : 'Playlist'}
    </DropdownMenu.Item>
  )
}

export default AddToPlaylist
